import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';
import { QrCodeComponent } from 'src/app/components/bloques/qr-code/qr-code.component';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-tickets-list',
  templateUrl: './tickets-list.component.html',
  styleUrls: ['./tickets-list.component.scss']
})
export class TicketsListComponent implements OnInit {

  @Input() compra!: any;
  @Input() type!: any;
  @Output() closeAction: EventEmitter<boolean> = new EventEmitter();
  urlEvents: string = AppSettings.MEDIA_URI + '/events_images/';

  constructor(
    private dialog: MatDialog,
    private reportService: ReportsService,
  ) { }

  ngOnInit(): void {


  }

  closeTickets() {
    this.closeAction.emit(this.type);
  }

  openQr(ticket: any) {
    this.dialog.open(QrCodeComponent, {
      panelClass: 'info-dialog',
      data: { localizador: ticket.localizador }
    });
  }

  printTicket(idOrder: number) {
    this.reportService.getUrlsDownload(idOrder).subscribe({
      next: (response) => {
        if (response && response.data) {
          if (response.data.ticket_a4) {
            this.downloadFromUrl(response.data.ticket_a4);
          } else {
            this.openInfoCard('No se pudo obtener la URL de descarga del ticket.', true, false);
          }
        } else {
          this.openInfoCard('No se pudo obtener la URL de descarga del ticket.', true, false);
        }
      }, error: (err) => {
        this.openInfoCard('Lo sentimos, no se han podido descargar las entradas.', true, false);
      }
    })
  }

  private downloadFromUrl(url: string) {
    const newWindow = window.open(url, '_blank');
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      window.location.href = url;
    }
    this.openInfoCard('Se ha abierto el ticket correctamente.', false, false);
  }

  openInfoCard(msg: string, disabledClose: boolean = false, icon: boolean = true) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false
      }
    });
  }
}
